<template>
  <div class="insurance-products  page-content">
    <section class="module__header">
      <h2 class="module__header__title">保险产品</h2>
      <p class="module__header__subtitle">Insurance products</p>
    </section>
    <section class="table-list">
      <table class="align-left">
        <thead>
          <tr>
            <th>保险产品</th>
            <th>条款名称</th>
            <th>备案编号</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in dataSource" :key="index">
            <td>{{ record.productName }}</td>
            <td>
              <p
                v-for="(clauseName, cIndex) in record.clauseNames"
                :key="cIndex"
              >
                {{ clauseName }}
              </p>
            </td>
            <td>
              <p v-for="(recordNo, rIndex) in record.recordNos" :key="rIndex">
                {{ recordNo }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <section class="card-list">
      <section class="card" v-for="record in dataSource">
        <section class="description">
          <span class="label">保险产品</span>
          <section class="value">{{ record.productName }}</section>
        </section>
        <section class="description">
          <span class="label">备案名称</span>
          <section class="value">
            <p v-for="(clauseName, cIndex) in record.clauseNames" :key="cIndex">
              {{ clauseName }}
            </p>
          </section>
        </section>
        <section class="description">
          <span class="label">备案编号</span>
          <section class="value">
            <p v-for="(recordNo, rIndex) in record.recordNos" :key="rIndex">
              {{ recordNo }}
            </p>
          </section>
        </section>
      </section>
    </section>
  </div>
</template>

<script>
import { get } from "lodash";
export default {
  name: "insurance-products",
  data() {
    return {
      dataSource: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/product/info/pcProductPage?pageSize=1000")
        .then((res) => {
          const records = get(res, "data.records");
          if (Array.isArray(records)) {
            this.dataSource = records.map((record) => {
              return {
                ...record,
                clauseNames:
                  Array.isArray(record.clauseNames) &&
                  record.clauseNames.length != 0
                    ? record.clauseNames
                    : ["-"],
                recordNos:
                  Array.isArray(record.recordNos) &&
                  record.recordNos.length != 0
                    ? record.recordNos
                    : ["-"],
              };
            });
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="less">
.insurance-products {
  background: #f6fafe;
}
@media all and (max-width: 1200px) {
  .insurance-products {
    .table-list {
      display: none;
    }
  }
}
</style>
